import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import SunEditor from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import mergeTag from "@modules/plugins/sunnote/SelectFields";
import {
    align,
    font,
    fontColor,
    fontSize,
    formatBlock,
    hiliteColor,
    horizontalRule,
    image,
    link,
    list,
    table,
    video
} from "suneditor/src/plugins";

const MailBodyEditorContent = (props) => {
    const [mailContent, setMailContent] = useState("");
    const [inputMode, setInputMode] = useState(null)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {content, mode, name, onlyAddFieldTool, onChange} = props

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        setInputMode(mode)
    }, [mode])

    useEffect(() => {
        console.log("MailBodyEditorContent: useEffect")
        if (content) {
            setMailContent(content)
        }

    }, [content]);

    const onChangeInput = (contents) => {
        if (mailContent !== contents) {
            setMailContent(contents)
            console.log("MailBodyEditorContent: onChangeInput")
            if (onChange) {
                onChange(contents)
            }
        }
    }

    const getButtonList = () => {
        if (onlyAddFieldTool) {
            return [[{
                name: 'select_fields',
                dataCommand: 'select_fields',
                buttonClass: 'mail-template-add-fields btn btn-success',
                title: 'Add fields',
                dataDisplay: 'submenu',
                innerHTML: '<span><b>Add fields</b></span>',
            }]]
        }

        return [['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'], ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
            ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print', 'save'],
            [{
                name: 'select_fields',
                dataCommand: 'select_fields',
                buttonClass: 'mail-template-add-fields btn btn-success',
                title: 'Add fields',
                dataDisplay: 'submenu',
                innerHTML: '<span><b>Add fields</b></span>',
            }]]
    }

    return (
        <div className={"row"}>
            <div className='col-sm-12'>
            </div>
            <div className={'col-sm-12'}>
                <SunEditor  name={name} setAllPlugins setOptions={{
                    height: onlyAddFieldTool ? 'auto' : 200,
                    plugins: [mergeTag, fontSize, formatBlock, font, align, list, horizontalRule,
                        fontColor, hiliteColor, table, link, image, video],
                    buttonList: getButtonList(),
                }} onChange={(contents) => onChangeInput(contents)}
                            setContents={mailContent}
                />
            </div>
        </div>
    )
}

export default MailBodyEditorContent;
